export const CLIENT = 'Client';
export const MANAGER = 'Manager';
export const EMPLOYEE = 'Employee';
export const ADMIN = 'Admin';
export const CSM_ADMIN = 'CSMAdmin';
export const SUPPORT_ADMIN = 'SupportAdmin';
export const PARTNER_USER = 'PartnerUser';

export function isTeamOwner(role) {
  return role === CLIENT;
}

export function isTeamLeader(role) {
  return role === MANAGER;
}

export function isTeamMember(role) {
  return role === EMPLOYEE;
}

export function isPartnerUser(role) {
  return role === PARTNER_USER;
}

export function isAdmin(role) {
  return role === ADMIN;
}

export function isSupportAdmin(role) {
  return role === SUPPORT_ADMIN;
}

export function isRogbot(role) {
  return role === CSM_ADMIN;
}

export function getPrettyRole(role) {
  let result;
  switch (role) {
    case CLIENT:
      result = 'Owner';
      break;
    case MANAGER:
      result = 'Team Leader';
      break;
    case EMPLOYEE:
      result = 'Team Member';
      break;
    case ADMIN:
      result = 'Admin';
      break;
    case CSM_ADMIN:
      result = 'CSM Admin';
      break;
    case SUPPORT_ADMIN:
      result = 'Support Admin';
      break;
    case PARTNER_USER:
      result = 'Partner';
      break;
    default:
      result = role;
  }
  return result;
}
